import {environment} from '../../../environments/environment';

export class Constants {

  // Configuracion
  API_URL = environment.apiProtocol + environment.apiUrl + ':' + environment.apiPort;
  API_REST = this.API_URL + '/apiAfingana/';
  URL_DESCARGA_FICHERO = this.API_REST + 'files/';
  URL_VER_PDF = this.API_REST + 'PDF/';
  URL_SOCKET = this.API_REST + 'socket';

  // ROLES USUARIO AFINGANA
  ROL_USUARIO_CLIENTE = 2;
  ROL_USUARIO_AFINGANA = 4;
  ROL_PROVEEDOR_CLIENTE = 1;

  // FORMATO COLUMNAS
  TEXT = 'text';
  CURRENCY = 'currency';
  DATE = 'date';
  CONTROL = 'control';
  DATETIME = 'datetime';
  NUMBER = 'number';
  INTEGER = 'integer';
  STRING = 'string';

  // COLUMNAS ESPECIALES
  GARANTIAS = 'Garantias';
  MOVIMIENTOS = 'Rendimientos';
  GASTOS_FIDEICOMISO = 'Gastos Fideicomiso'
  CORRIDA_FINANCIERA = 'Corrida Financiera';
  RENOVACION = 'Renovación';
  EDITAR = 'Editar';
  DOMICILIOS = 'Domicilios';
  CONTACTOS = 'Contactos';
  DOCUMENTOS = 'Documentos';
  CLIENTES = 'Clientes';
  SOLICITUD = 'Solicitud';
  ACTUALIZAR_TABLA = 'ActualizarTabla';
  RESET_TABLA = 'Reset Tabla';
  AGREGAR = 'Agregar';
  VISUALIZAR = 'Visualizar';
  RELOJ = 'Pendiente Finalizar Proceso';
  ELIMINAR = 'Eliminar';
  ELIMINAR_DOCUMENTACION = 'Eliminar Documentacion';
  XML = 'XML';
  CARTA = 'Carta';
  PDF = 'PDF';
  TIPO_CAMBIO = 'Tipo de Cambio';
  EMAIL = 'Enviar Email';
  NOTIFICADO = 'Notificado Email';
  CUENTAS_BANCARIAS = 'Cuentas Bancarias';
  INMUEBLES = 'Inmuebles del Desarrollo Mobiliario';
  PROPIETARIOS = 'Propietarios';
  CONDICIONES = 'Condiciones Contratos';
  CONTRATOS = 'Contratos / Prorrogas';
  BUSCAR = 'Buscar';
  RESET = 'Reset';
  CONVENIOS = 'Convenios';
  ARRENDADORES = 'Arrendadores';
  FACTURACION_CONDICIONES = 'Facturación Condiciones';
  UPLOAD = 'Cargar Documento';
  VALIDAR = 'Validar Registro';
  REVISADO = 'Revisado';
  MOVIMIENTO_AFIN = 'Movimiento por AFIN';
  CANCELAR = 'Cancelar Registro';
  PAGADO = 'Pagado';
  CUENTAS_CONTABILIDAD = 'Cuentas Contabilidad';
  REQUISICION = 'Requisición Relacionada';
  VALIDAR_CFDI = 'Validar CFDI SAT';
  CANCELAR_CFDI = 'Cancelar CFDI';
  TERCEROS = 'Terceros';
  DESCARGAR = 'Descargar';

  /** TABLAS **/
  PSACCION = 'psaccion';
  FICORFIN = 'ficorfin';
  PSADJTER = 'psadjter';
  FIMOVINV = 'fimovinv';
  FICORPAG = 'ficorpag';
  FICORRET = 'ficorret';
  FIMOVIMI = 'fimovimi';

  // Usuarios Especiales
  USUARIOS_ESPECIALES = [];

  // Rutas SFTP
  psadjter_sftp = 'com.afingana.terceros.adjuntos';
  fipagos_sftp = 'com.afingana.lotes.adjuntos';
  filotes_sftp = 'com.afingana.lotes.adjuntos';
  personas_sftp = 'com.afingana.personas.adjuntos';
  ficorret_sftp = 'com.afingana.rendimientos.adjuntos';
  fimovimi_sftp = 'com.afingana.fideicomisos.adjuntos';


}
